import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconOpen = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_open_light"
      data-name="UI icon/open/light"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
    >
      <path
        id="Union"
        d="M6.667,5A.833.833,0,1,0,8.333,5V1.667A1.667,1.667,0,0,0,6.667,0H3.333a.833.833,0,0,0,0,1.667H5.488L.244,6.911A.833.833,0,0,0,1.423,8.089L6.667,2.845Z"
        transform="translate(6.667 0)"
        fill={color}
      />
      <path
        id="Vector_598_Stroke_"
        data-name="Vector 598 (Stroke)"
        d="M0,2.5A2.5,2.5,0,0,1,2.5,0H6.667a.833.833,0,1,1,0,1.667H2.5a.833.833,0,0,0-.833.833v10a.833.833,0,0,0,.833.833h10a.833.833,0,0,0,.833-.833V8.333a.833.833,0,0,1,1.667,0V12.5A2.5,2.5,0,0,1,12.5,15H2.5A2.5,2.5,0,0,1,0,12.5Z"
        transform="translate(0 0)"
        fill={color}
      />
    </svg>
  );
};

export default IconOpen;
